export default __webpack_public_path__ + "ec05946a40b6fb711907ced838f868a3.jpg";